import {MouseEvent, useCallback, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ActionCreatorWithPayload} from '@reduxjs/toolkit';

import {reachGoal, YM_GOALS} from 'shared/lib/analytics';

import {SelectionSelector} from './createSelectionSlice';

type GoalName = typeof YM_GOALS[keyof typeof YM_GOALS];

export type MonitorRowClickHandler = (_event: MouseEvent) => void;

export const useMonitorRowState = <T extends string | null>() => {
    const [activeModal, setActiveModal] = useState<T | null>(null);

    const closeModal = useCallback(() => setActiveModal(null), []);

    const openModal = (type: NonNullable<T>, goal?: GoalName): MonitorRowClickHandler => (event) => {
        event.stopPropagation();
        if (goal) {
            reachGoal(goal);
        }
        setActiveModal(type);
    };

    return {activeModal, setActiveModal, closeModal, openModal};
};

export const useMonitorRowSelection = (
    uuid: string,
    selectedIdsSelector: SelectionSelector<string[]>,
    toggleOne: ActionCreatorWithPayload<string>,
) => {
    const dispatch = useDispatch();
    const selectedIds = useSelector(selectedIdsSelector);

    return {
        isSelected: selectedIds.includes(uuid),
        onCheckboxChange: () => {
            dispatch(toggleOne(uuid));
        },
    };
};
